import React, { Component} from 'react';
import { connect } from "react-redux";
import { Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter, Card, CardBody, CardHeader } from "reactstrap";
import { NotificationManager } from "react-notifications";
import LoadingSpinner from "../../components/LoadingSpinner/index";
import DataTable from "../../components/Table/Table";
import "react-table/react-table.css";
import { Link } from "react-router-dom";
import {getCastConfigs, deleteCastConfig,setCastPageInfo} from "../../actions/actionCast.js"

class CastConfig extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            filterId: null,
        };

        this.cancelDelete = this.cancelDelete.bind(this);
        this.deleteConfirm = this.deleteConfirm.bind(this);
        this.deleteCastAction = this.deleteCastAction.bind(this);
        this.handleDeleteSuccess = this.handleDeleteSuccess.bind(this);
        this.handleDeleteError = this.handleDeleteError.bind(this);
    }

    componentDidMount() {
        this.props.getCastConfigs();
    }

    deleteConfirm(castConfigId){
        this.setState({modal: !this.state.modal,
            castConfigId: castConfigId});
    }

    cancelDelete(){
        this.setState({modal: !this.state.modal});
    }

    deleteCastAction(){
        this.props.deleteCastConfig(this.state.castConfigId).
        then(() => this.handleDeleteSuccess()).
        catch(() => this.handleDeleteError());
    }

    handleDeleteSuccess(){
        const {deleteCastErrorMessage} = this.props;
        if(deleteCastErrorMessage) {
            NotificationManager.error(deleteCastErrorMessage,"Delete Casting Config Failed", 3000);
        }else{
            NotificationManager.success("Successfully Deleted Casting Config","Delete Casting Config", 3000);
            this.setState({modal: false});
            this.props.getCastConfigs();
        }
    }

    handleDeleteError(){
        const {deleteCastError} = this.props;
        if(deleteCastError){
            NotificationManager.error(deleteCastError,"Failed to Delete Casting Config", 3000);
            this.props.history.push("/cast");
        }else{
            NotificationManager.error("Failed to Delete Casting Config","Delete Casting Config", 3000);
            this.props.history.push("/cast");
        }
    }

    render() {
        if (this.props.getCastLoading) {
            return (<div> <LoadingSpinner /></div>);
        }
        
        const {cast_configs} = this.props;

        const tableColumns = [
            {
                type: "text",
                name: "URL",
                accessor: "key",
                filterable: true,
                sortable: true,
                cell: (data) => <div>{"https://" + window.location.host + "/#/cast/" + data.value}</div>
            },
            {
                type: "text",
                name: "Image",
                accessor: "image_friendly_name",
                filterable: false,
                sortable: true
            },
            {
                type: "text",
                name: "Sessions Remaining",
                accessor: "session_remaining",
                filterable: true,
                sortable: true
            },
            {
                type: "flag",
                name: "Anonymous",
                accessor: "allow_anonymous",
                filterable: true,
                sortable: true
            }
        ];

        const actions = [
            { id: "view", icon: "fa-eye", description: "View" },
            { id: "edit", icon: "fa-pencil", description: "Edit" },
            { id: "delete", icon: "fa-trash", description: "Delete" },
        ];

        const onAction = (action, item) => {
            switch (action) {
                case "view":
                    this.props.history.push(`/viewcast/${item.cast_config_id}`);
                break;

                case "edit":
                    this.props.history.push(`/updatecast/${item.cast_config_id}`);
                break;

                case "delete":
                    this.deleteConfirm(item.cast_config_id);
                break;
            }
        }

        return(
            <div className="profile-page">
                <Row>
                    <Col sm={{ size: 10, order: 3, offset: 1 }}>
                        <Card >
                            <CardHeader>
                            <div className="title-head">
                                <i className="fa fa-rss fa-rotate-90"></i> <strong>Session Casting</strong></div>
                                <Link className="pull-right add-btn" to={{ pathname: "/createcast" }}>
                                    <button className="pull-right adduser-btn" size="sm" color="dark">
                                    <i className="fa fa-plus" aria-hidden="true"></i>
                                    Add Config
                                    </button>
                                </Link>
                            </CardHeader>
                            <CardBody className="p-0">
                                <DataTable
                                    id="casts"
                                    data={cast_configs}
                                    columns={tableColumns}
                                    actions={actions}
                                    onAction={onAction}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <Modal isOpen={this.state.modal} toggle={this.cancelDelete} className="user-modal">
                    <ModalHeader toggle={this.cancelDelete}>Are you sure you want to delete this config?
                    </ModalHeader>
                    <ModalFooter>
                        <Button onClick={this.cancelDelete} size="sm" 
                        className="cancel-button"
                        color=" basic"> Close</Button>
                        <Button onClick={this.deleteCastAction} 
                        className="delete-button"
                        size="sm" color="danger">Delete</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }

}

export default connect(state => ({
        cast_configs: state.cast.cast_configs || [],
        getCastLoading: state.cast.getCastLoading || false,
        getCastErrorMessage: state.cast.getCastErrorMessage || false,
        getCastError: state.cast.getCastError || null,
        deleteCastErrorMessage: state.cast.deleteCastErrorMessage || null,
        deleteCastError: state.cast.deleteCastError || null,
        deletedCast: state.cast.deletedCast || null,
        deleteCastLoading: state.cast.deleteCastLoading || null,
        pages : {pageSize : state.cast.pageSize, pageNo : state.cast.pageNo},
    }),
    dispatch => ({
        getCastConfigs: () => dispatch(getCastConfigs()),
        deleteCastConfig: (data) => dispatch(deleteCastConfig(data)),
        setPageInfo : (data)=> dispatch(setCastPageInfo(data)),

    }))(CastConfig);



// WEBPACK FOOTER //
// ./src/views/CastConfig/Cast.js